import React,{useState} from 'react'
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'components/common/ThemeContext';
import { FaMoon, FaSun } from 'react-icons/fa';
import { BiLogOut } from 'react-icons/bi';

const Header = () => {

    const navigate = useNavigate();
    const { theme, toggleTheme } = useTheme();
    const [isOpen, setIsOpen] = useState(false)

const handleLogOut = () => {
    localStorage.removeItem('jwt')
    navigate('/auth/login')
}

  return (
    // <div className='sticky top-0 bg-[#1E1E1E] dark:bg-red-500 flex px-5 py-4 justify-between items-center'>
    //    <img alt="logo" src="/logo-wide.png" className='md:w-[220px] sm:w-[200px] xs:w-[160px] object-contain'/>
    //    <button onClick={handleLogOut} className='bg-blue-500 text-white py-3 text-[16px] font-semibold rounded-full px-5'>
    //     Log out
    //   </button>
     <div className='w-full z-40 flex px-4 pb-4 justify-end h-[128px] sticky top-0 bg-[#FFF] dark:bg-[#0F0F0F]'>
      <div className='flex flex-col md:flex-row items-center w-full mt-auto justify-end'>
      <div className='flex items-center md:hidden my-5'>
        <p className='dark:text-white mr-3 text-black text-[16px] font-bold font-InterBold'>Powered by </p>
        <img
          alt="logo"
          src={theme === 'dark' ? '/logo-wide.png' : '/dark-logo.png'}
          className='w-[113px] h-[29px] object-contain'
        />
      </div>
      {/* <input
      placeholder='Search'
        className='w-[368px] hidden md:flex bg-transparent font-Inter px-3 rounded-[10px] h-[37px] flex-shrink-0' 
        style={{border:'1px solid #949494'}}
      /> */}
      <div className='flex items-center'>
    
        {/* <button className='w-[79px] cursor-pointer font-Inter mr-5  text-[#9757F6] dark:text-[#C8AFFF] text-[12px] h-[35px] bg-[#E0DAEC] dark:bg-[#35255D] rounded-[10px]'>
          Upgrade
        </button> */}
        <div className='px-5 border-r-2  border-[#DFE0E3]'>
        <div
          onClick={toggleTheme} 
          className='w-[33px] cursor-pointer  border-2 rounded-[10px] border-[#DFE0E3] dark:border-black h-[35px] flex items-center justify-center bg-[#E0DAEC] dark:bg-[#2C2D31]'
        >
          {theme === 'light' ? <FaMoon className='w-5 h-5 text-black dark:text-[#B3B3B3]'/> : <FaSun className='w-5 h-5 text-black dark:text-[#B3B3B3]'/>}
        </div>
        </div>
        <div onClick={() => setIsOpen(!isOpen)} className='bg-[#679F38] cursor-pointer relative ml-5 w-[34px] h-[34px] rounded-full flex justify-center items-center'>
          <p className='text-[21px] text-[#fff] font-Inter'>A</p>
          {isOpen && (
          <div onClick={handleLogOut} className='absolute p-3 top-10 border-2 rounded-[10px] right-0 bg-[#FFF] dark:bg-[#0F0F0F] py-2 w-[160px]'>
            <div className='flex items-center'>
              <BiLogOut className='text-black dark:text-white text-[25px]'/>
              <p className='font-bold ml-3 text-[16px] font-Inter dark:text-white'>Log Out</p>
            </div>
          </div>
          )}
        </div>
      </div>
     </div>
     </div>
  )
}

export default Header
